<template>
  <div class="mt-8">
    <vs-row class="flex flex-wrap items-center my-4">
      <h5 class="mb-4 xl:mb-0"><i class="dot"></i> {{ title }}</h5>
      <div class="ml-auto flex flex-wrap gap-4" v-if="!readonly">
        <AlertUserSelector ref="refUserSelector" class="w-full" type="" :is-part-name="true" v-model="selectedUser" :fullData="true" :readonly="readonly" style="display: none" @select="addUsers" />
        <vs-button color="secondary" type="border" @click="refreshMemberData">작업자 정보 업데이트</vs-button>
        <vs-button color="secondary" type="border" @click="refreshEnterExitTime">입출문 이력</vs-button>
        <vs-button color="secondary" @click="addItems">인원추가</vs-button>
        <vs-button color="secondary" type="border" @click="deleteItems" :disabled="selected.length === 0">선택삭제</vs-button>
      </div>
    </vs-row>

    <div class="overflow-x-auto">
      <vs-table :multiple="!readonly" v-model="selected" :data="localValue" class="w-full table" noDataText="데이터가 없습니다" style="min-width: 1600px">
        <template slot="thead">
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 80px">구분</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 120px">성명</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 100px">직위(직책)</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 160px">생년월일(6자리)</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 120px">연락처</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 120px">건설업 기초안전보건 교육 수료증</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 100px">내국인/외국인</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 180px">건강정보(수축/이완)</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 100px">작업가능 여부</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 120px">교육만료 일자</div></vs-th>
          <vs-th class="table-header">
            <div class="w-full text-center" style="min-width: 120px">작업자안전<br />교육만료 일자</div></vs-th
          >
          <vs-th v-if="useConfinedSpaceWork" class="table-header">
            <div class="w-full text-center" style="min-width: 120px">밀폐공간작업<br />교육만료 일자</div></vs-th
          >
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 120px">변동인원 증빙</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 140px">입문시간</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center" style="min-width: 140px">출문시간</div></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr" style="box-shadow: none !important; transform: translateY(0px)">
            <!-- 구분 -->
            <vs-td>
              <div class="text-center">{{ tr.구분 }}</div>
            </vs-td>

            <!-- 성명 -->
            <vs-td>
              <div v-if="readonly" class="print-input">{{ tr.성명.name }}</div>
              <member-selector v-model="tr.성명.id" :member-name="tr.성명.name" popup-type="user" :disabledUserIds="disabledUserIds" @select="(member) => onSelectUser(indextr, member)" />
              <div v-if="tr.error" class="mt-1 flex gap-2" style="color: #ea5455; font-weight: 500">
                <svg style="min-width: 18px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                    fill="#EA5455"
                  />
                </svg>
                <span>{{ tr.error }}</span>
              </div>
            </vs-td>

            <!-- 직위(직책) -->
            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.직위 }}</div>
              <vs-select v-else class="w-full flex-1" autocomplete v-model="tr.직위">
                <vs-select-item v-for="option in 직위옵션" :key="option" :text="option" :value="option" />
              </vs-select>
            </vs-td>

            <!-- 생년월일(6자리) -->
            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.생년월일.padStart(6, "0") }}</div>
              <ml-input v-else readonly :value="tr.생년월일.padStart(6, '0')" class="w-full flex-1" @click.stop />
              <p v-if="tr.err65" class="mt-1" style="font-weight: 400; font-size: 12px; line-height: 17px; text-align: left; color: #ea5455">만 65세 이상 작업자입니다.</p>
            </vs-td>

            <!-- 연락처 -->
            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.연락처 }}</div>
              <HyphenInput v-else readonly :isNoHyphenData="true" :setting="[{ max: 3, hidden: true }, { max: 4, hidden: true }, { max: 4 }]" v-model="tr.연락처" class="w-full flex-1" @click.stop />
            </vs-td>

            <!-- 건설업 기초안전 보건 교육 수료증 -->
            <vs-td class="text-center">
              <file-uploader v-model="tr.기초안전보건교육수료증" :readonly="readonly" />
            </vs-td>

            <!-- 내국인/외국인 -->
            <vs-td class="text-center">
              <vs-radio v-model="tr.is_foreigner" vs-value="내국인" :vs-name="`is_foreigner${indextr}`" :disabled="readonly">내국인</vs-radio>
              <vs-radio v-model="tr.is_foreigner" vs-value="외국인" :vs-name="`is_foreigner${indextr}`" :disabled="readonly">외국인</vs-radio>
            </vs-td>

            <!-- 건강정보(수축/이완) -->
            <vs-td class="text-center">
              <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
                <number-input v-model="tr.건강정보_수축" :readonly="readonly" :min="0" :max="500" @click.stop style="width: 60px" @input="() => refreshHealthInfoError(tr)" />
                <div style="margin: 0 5px">/</div>
                <number-input v-model="tr.건강정보_이완" :readonly="readonly" :min="0" :max="500" @click.stop style="width: 60px" @input="() => refreshHealthInfoError(tr)" />
              </div>
              <div v-if="checkAccessRestriction && tr.건강정보error" v-for="_he in tr.건강정보error" :key="`건강정보_에러_${_he}`" class="mt-1 flex gap-2" style="color: #ea5455; font-weight: 500">
                <svg style="min-width: 18px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                    fill="#EA5455"
                  />
                </svg>
                <span class="text-left">{{ _he }}</span>
              </div>
            </vs-td>

            <!-- 작업가능 여부 -->
            <vs-td>
              <vs-radio v-model="tr.작업가능여부" vs-value="가능" :vs-name="`작업가능여부${indextr}`" :disabled="readonly || !isSafetyManager">가능</vs-radio>
              <vs-radio v-model="tr.작업가능여부" vs-value="불가능" :vs-name="`작업가능여부${indextr}`" :disabled="readonly || !isSafetyManager">불가능</vs-radio>
            </vs-td>

            <!-- 교육만료 일자 -->
            <vs-td class="text-center">
              <!-- input -->
              <div v-if="readonly" class="print-input">{{ tr.교육만료일자 }}</div>
              <date-selector v-else-if="![914, 915, 916, 917].includes(parseInt(tr.company_id))" v-model="tr.교육만료일자" :minDate="minDate" :readonly="true" @input="() => (tr.교육만료일자error = '')" />
              <div v-else>-</div>

              <!-- error -->
              <div v-if="![914, 915, 916, 917].includes(parseInt(tr.company_id)) && tr.교육만료일자error" class="mt-1 flex gap-2" style="color: #ea5455; font-weight: 500">
                <svg style="min-width: 18px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                    fill="#EA5455"
                  />
                </svg>
                <span class="text-left">{{ tr.교육만료일자error }}</span>
              </div>
            </vs-td>

            <!-- 작업자안전 교육만료 일자 -->
            <vs-td class="text-center">
              <!-- input -->
              <div v-if="readonly" class="print-input">{{ tr.작업자안전교육만료일자 }}</div>
              <date-selector v-else-if="![914, 915, 916, 917].includes(parseInt(tr.company_id))" v-model="tr.작업자안전교육만료일자" :minDate="minDate" :readonly="true" @input="() => (tr.작업자안전교육만료일자error = '')" />
              <div v-else>-</div>

              <!-- error -->
              <div v-if="![914, 915, 916, 917].includes(parseInt(tr.company_id)) && tr.작업자안전교육만료일자error" class="mt-1 flex gap-2" style="color: #ea5455; font-weight: 500">
                <svg style="min-width: 18px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                    fill="#EA5455"
                  />
                </svg>
                <span class="text-left">{{ tr.작업자안전교육만료일자error }}</span>
              </div>
            </vs-td>

            <!-- 밀폐작업 교육만료 일자 -->
            <vs-td v-if="useConfinedSpaceWork" class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.밀폐공간안전교육만료일자 }}</div>
              <date-selector v-else v-model="tr.밀폐공간안전교육만료일자" :minDate="minDate" :readonly="true" />
              <div v-if="tr.밀폐공간안전교육만료일자error" class="mt-1 flex gap-2" style="color: #ea5455; font-weight: 500">
                <svg style="min-width: 18px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                    fill="#EA5455"
                  />
                </svg>
                <span class="text-left">{{ tr.밀폐공간안전교육만료일자error }}</span>
              </div>
            </vs-td>

            <!-- 변동인원 증빙 -->
            <vs-td class="text-center">
              <div v-if="!tr.변동인원증빙대상">비대상</div>
              <file-uploader v-else v-model="tr.변동인원증빙" :readonly="readonly" />
            </vs-td>

            <!-- 입문시간 -->
            <vs-td class="text-center">
              <div v-if="readonly || !isSafetyManager" class="print-input">{{ tr.입문시간 }}</div>
              <time-selector v-else v-model="tr.입문시간" :readonly="readonly" @change="(value) => changeIntroductionTime(value, tr)" :maxTime="tr.출문시간" />
            </vs-td>
            <!--   -->

            <!-- 출문시간 -->
            <vs-td class="text-center">
              <div v-if="readonly || !isSafetyManager || !tr.입문시간" class="print-input">{{ tr.출문시간 }}</div>
              <time-selector v-else v-model="tr.출문시간" :readonly="readonly" :minTime="tr.입문시간" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";
import FileUploader from "@/components/FileUploader.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import { 직위옵션 } from "@/views/boards/single-page/976/selectOptions";
import moment from "moment";
import * as UiUtil from "@/util/UiUtil";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";
import { applyEducationExpirationToUser } from "@/util/TrainingVideo";
import HttpRequest from "@/util/HttpRequest";
import { checkHealthInfoExpiration, hasHealthInfoValue } from "@/views/boards/single-page/976/healthInfo";

export default {
  name: "WorkerList976",
  components: {
    AlertUserSelector,
    MemberSelector,
    TimeSelector,
    DateSelector,
    NumberInput,
    FileUploader,
    SimpleSpinner,
    PhotoUploadGridModule,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "작업자 내역",
    },
    startDate: String,
    endDate: String,
    qrList: {
      type: Array,
      default: () => [],
    },
    refreshQrList: Function,
    // 안전관리자 권한을 갖고있는지
    isSafetyManager: {
      type: Boolean,
      default: false,
    },
    checkAccessRestriction: Boolean,
    // 밀폐공간 작업 사용여부
    useConfinedSpaceWork: Boolean,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    disabledUserIds() {
      return this.localValue.map((item) => item.userId);
    },

    minDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
  watch: {
    qrList(value) {
      if (value && value.length > 0) {
        if (this.updateQrTime) {
          this.updateQrTime(true);
        }
      }
    },
  },
  data() {
    return {
      selectedUser: [],
      selected: [],
      직위옵션,
    };
  },
  mounted() {},
  methods: {
    addItems() {
      this.$refs.refUserSelector.onClickOpenPopup();
    },

    deleteItems() {
      this.localValue = this.localValue.filter((item) => !this.selected.map((item) => item.userId).includes(item.userId));
      this.selectedUser = this.selectedUser.filter((user) => !this.selected.map((item) => item.userId).includes(user.id));
      this.selected = [];
    },

    converterUserDate(user) {
      let 교육만료일체크여부 = true;
      // 해당 업체는 교육만료일을 체크하지 않음
      if ([914, 915, 916, 917].includes(parseInt(user.company_id))) {
        교육만료일체크여부 = false;
      }
      const metas = this.transformToMeta(user.metas);

      // 내국인:false, 외국인:true
      let is_foreigner = "내국인";
      if (typeof metas.is_foreigner === "string") {
        try {
          is_foreigner = JSON.parse(metas.is_foreigner) ? "외국인" : "내국인";
        } catch (e) {
          console.log("is_foreigner 가 JSON 형식이 아닙니다.", metas.is_foreigner);
        }
      } else if (typeof metas.is_foreigner === "boolean") {
        is_foreigner = metas.is_foreigner ? "외국인" : "내국인";
      }

      // 간혹 rrn(7자리, YYMMDD{gender}) 을 받아올때 앞자리수가 0인경우에 값을 받아오지 못하는 경우를 대비
      // rrn2값 이 1,2,3,4 인 경우에 따라 생년월일을 계산 추가 (976, 981) 2025-04-18
      const rrn = metas.rrn ? `${metas.rrn}`.padStart(7, "0") : "";
      const 생년월일 = rrn.length === 7 ? rrn.substring(0, 6) : "";
      const rrn2 = rrn.length === 7 ? rrn.substring(6, 7) : "";

      let err65 = false;
      if (생년월일 && rrn2) {
        const currentYear = new Date().getFullYear();
        let birthYear = parseInt(생년월일.substring(0, 2), 10);

        // 뒷자리수에 따른 세기 결정
        if (rrn2 === "1" || rrn2 === "2") {
          // 1900년대생
          birthYear += 1900;
        } else if (rrn2 === "3" || rrn2 === "4") {
          // 2000년대생
          birthYear += 2000;
        } else {
          // 그 외의 경우 기존 로직 유지
          const currentCentury = Math.floor(currentYear / 100) * 100;
          birthYear += birthYear <= currentYear % 100 ? currentCentury : currentCentury - 100;
        }

        const age = currentYear - birthYear - 1;
        err65 = age >= 65;
      }

      // 안전한 참조를 위한 유틸리티 함수
      const safeGet = (obj, path, defaultValue = {}) => {
        if (!obj) return defaultValue;
        const value = path.split(".").reduce((o, p) => {
          return o && o[p] !== undefined ? o[p] : undefined;
        }, obj);
        return value !== undefined ? value : defaultValue;
      };

      let 교육만료일자error = "";
      if (교육만료일체크여부) {
        교육만료일자error = this.checkEducationExpiration(safeGet(metas, "안전교육만료일", ""), "교육만료일자");
      }

      let 작업자안전교육만료일자error = "";
      if (교육만료일체크여부) {
        작업자안전교육만료일자error = this.checkEducationExpiration(safeGet(metas, "작업자안전교육만료일", ""), "작업자안전교육만료일자");
      }

      const 밀폐공간안전교육만료일자error = this.checkEducationExpiration(safeGet(metas, "밀폐공간안전교육만료일", ""), "밀폐공간안전교육만료일자");

      return {
        // 공통데이터
        id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        company_id: user.company_id,
        userId: user.id,
        userName: user.name,
        성명: {
          id: user.id,
          name: user.name,
        },
        직위: "", // 회원가입시 입력하는 직책과 다를 수 있어서 값을 받아오지 않음
        연락처: user.mobile || user.phone,
        생년월일,
        rrn2,
        err65,
        주소: user.home_address_1,
        우편번호: user.home_zip,
        기초안전보건교육수료증: safeGet(metas, "건설업기초안전교육"),
        건설기계조종사면허번호: safeGet(metas, "건설기계조종사면허번호", ""),
        is_foreigner,

        // 전용데이터
        구분: "변동",
        건강정보유효기간: safeGet(metas, "유효기간", ""),
        건강정보_수축: safeGet(metas, "수축", ""),
        건강정보_이완: safeGet(metas, "이완", ""),
        건강정보error: this.checkHealthInfoExpiration(safeGet(metas, "유효기간", ""), safeGet(metas, "수축", ""), safeGet(metas, "이완", "")),
        작업가능여부: "",
        교육만료일자: safeGet(metas, "안전교육만료일", ""),
        교육만료일자error,
        작업자안전교육만료일자: safeGet(metas, "작업자안전교육만료일", ""),
        작업자안전교육만료일자error,
        밀폐공간안전교육만료일자: safeGet(metas, "밀폐공간안전교육만료일", ""),
        밀폐공간안전교육만료일자error,
        입문시간: "",
        출문시간: "",
        변동인원증빙대상: true,
        변동인원증빙: {},
      };
    },

    // 건강정보 체크 (필수 입력 항목은 아니며, 안내 문구만 표시한다)
    checkHealthInfoExpiration(유효기간, 수축, 이완) {
      return checkHealthInfoExpiration(유효기간, 수축, 이완);
    },

    // 건강정보를 다시 확인하여 안내 문구를 갱신한다.
    refreshHealthInfoError(member) {
      this.$set(member, "건강정보error", checkHealthInfoExpiration(member.건강정보유효기간, member.건강정보_수축, member.건강정보_이완));
    },
    // 안전교육 만료일자 체크
    checkEducationExpiration(안전교육만료일, 교육종류) {
      const today = moment();
      const educationExpirationDate = moment(안전교육만료일);

      let 만료문구 = "안전교육 기간이 만료되었습니다.";
      let 이수문구 = "교육이수일이 없습니다. 안전보건 교육을 수강해주세요.";

      if (교육종류 === "작업자안전교육만료일자") {
        만료문구 = "작업자 안전교육 기간이 만료되었습니다.";
        이수문구 = "작업자 안전교육 이수일이 없습니다. 작업자 안전보건 교육을 수강해주세요.";
      } else if (교육종류 === "밀폐공간안전교육만료일자") {
        만료문구 = "밀폐공간 안전교육 기간이 만료되었습니다.";
        이수문구 = "밀폐공간 안전교육 이수일이 없습니다. 밀폐공간 안전보건 교육을 수강해주세요.";
      }

      if (!안전교육만료일) return 이수문구;
      if (educationExpirationDate.isBefore(today, "day")) return 만료문구;
      return "";
    },

    transformToMeta(metas) {
      const meta = {};

      if (!metas || !Array.isArray(metas)) {
        return meta;
      }

      metas.forEach((item) => {
        // 유효한 객체인지 확인하고 meta_key, meta_value가 존재하는지 확인
        if (!item || typeof item !== "object" || !item.meta_key) {
          return;
        }

        const meta_key = item.meta_key;
        const meta_value = item.meta_value === "undefined" ? undefined : item.meta_value;

        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = meta_value === undefined ? undefined : /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },

    onSelectUser(index, user) {
      this.$set(this.localValue, index, this.converterUserDate(user));
      this.memberDataUpdate();
    },

    async addUsers(users) {
      this.selectedUser = users;

      // this.localValue 항목 중에서, users[*].id 가 없는 항목을 제거합니다.
      this.localValue = this.localValue.filter((item) => users.map((user) => user.id).includes(item.userId));

      // users[*].id 가 localValue[*].userId 에 없는 항목을 추가합니다.
      users.forEach((user) => {
        if (!this.localValue.map((item) => item.userId).includes(user.id)) {
          this.localValue.push(this.converterUserDate(user));
        }
      });

      // localValue 를 갱신합니다.
      this.localValue = this.localValue.map((item) => {
        return {
          ...item,
        };
      });

      await this.memberDataUpdate();
    },

    generateRandomId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },

    async refreshMemberData() {
      try {
        UiUtil.loading(true);
        // 회원정보는 항상 최신 값을 사용해야 하므로 캐시를 사용하지 않고 조회한다.
        const response = await HttpRequest.get("/api/v1/member", {
          params: {
            projectId: this.projectId,
            userIds: this.localValue.map((member) => member.userId),
            page: 1,
            perPage: 10000,
          },
        });

        for (const user of response.data) {
          const index = this.localValue.findIndex((member) => member.userId === user.id);
          if (index === -1) {
            continue;
          }

          const prev = this.localValue[index];
          const userData = this.converterUserDate(user);
          delete userData.직위;

          // 회원정보에 건강정보가 등록되어 있지 않은 경우에는 화면에 입력된 값을 유지한다.
          if (!hasHealthInfoValue(userData.건강정보_수축)) userData.건강정보_수축 = prev.건강정보_수축;
          if (!hasHealthInfoValue(userData.건강정보_이완)) userData.건강정보_이완 = prev.건강정보_이완;
          if (!hasHealthInfoValue(userData.건강정보유효기간)) userData.건강정보유효기간 = prev.건강정보유효기간;

          // 구분 값이 없는 경우(과거 데이터 등)에는 변동으로 처리
          const 구분 = prev.구분 || "변동";
          const member = { ...prev, ...userData, 구분 };
          member.건강정보error = checkHealthInfoExpiration(member.건강정보유효기간, member.건강정보_수축, member.건강정보_이완);

          this.$set(this.localValue, index, member);
        }
      } catch (e) {
        console.error("refreshMemberData error", e);
      } finally {
        UiUtil.loading(false);
      }

      await this.memberDataUpdate();
    },

    async memberDataUpdate() {
      // 교육만료일자를 체크한다.
      await this.loadTrainingEndDate();

      // 입/출문 시간을 체크한다.
      this.updateQrTime(true);

      // 작업가능여부
      for (const member of this.localValue) {
        if (member.교육만료일자error) {
          member.작업가능여부 = "불가능";
        } else {
          member.작업가능여부 = "가능";
        }
      }
      this.$emit("select", this.localValue);
    },

    refreshEnterExitTime() {
      if (this.refreshQrList) {
        this.refreshQrList();
      }
      this.updateQrTime(true);
    },

    /**
     * 교육만료일자를 가져온다.
     * @returns {void}
     */
    async loadTrainingEndDate() {
      if (this.localValue) {
        UiUtil.loading(true);
        try {
          const localValue = JSON.parse(JSON.stringify(this.localValue));
          for (let i = 0; i < localValue.length; i++) {
            const user = localValue[i];

            // userId가 있는 경우에만 교육만료일자를 가져온다.
            if (user.userId) {
              const 교육만료일자 = await applyEducationExpirationToUser(this.$store.dispatch, {
                projectId: this.projectId,
                userId: user.userId,
              });
              const 기본교육만료일자 = 교육만료일자.기본교육만료일 || "";
              const 작업자안전교육만료일자 = 교육만료일자.작업자교육만료일 || "";
              const 밀폐공간안전교육만료일자 = 교육만료일자.밀폐공간교육만료일 || "";

              // 기존 교육만료일자와 비교하여 더 최근의 날짜로 업데이트
              if (user.교육만료일자) {
                user.교육만료일자 = new Date(기본교육만료일자).getTime() > new Date(user.교육만료일자).getTime() ? 기본교육만료일자 : user.교육만료일자;
              } else {
                user.교육만료일자 = 기본교육만료일자;
              }
              user.교육만료일자error = this.checkEducationExpiration(user.교육만료일자, "교육만료일자");

              // 작업자안전교육만료일자
              if (user.작업자안전교육만료일자) {
                user.작업자안전교육만료일자 = new Date(작업자안전교육만료일자).getTime() > new Date(user.작업자안전교육만료일자).getTime() ? 작업자안전교육만료일자 : user.작업자안전교육만료일자;
              } else {
                user.작업자안전교육만료일자 = 작업자안전교육만료일자;
              }
              user.작업자안전교육만료일자error = this.checkEducationExpiration(user.작업자안전교육만료일자, "작업자안전교육만료일자");

              // 밀폐공간안전교육만료일자
              if (user.밀폐공간안전교육만료일자) {
                user.밀폐공간안전교육만료일자 = new Date(밀폐공간안전교육만료일자).getTime() > new Date(user.밀폐공간안전교육만료일자).getTime() ? 밀폐공간안전교육만료일자 : user.밀폐공간안전교육만료일자;
              } else {
                user.밀폐공간안전교육만료일자 = 밀폐공간안전교육만료일자;
              }
              user.밀폐공간안전교육만료일자error = this.checkEducationExpiration(user.밀폐공간안전교육만료일자, "밀폐공간안전교육만료일자");
            }
          }

          // localValue 를 갱신합니다.
          this.localValue = localValue;
        } catch (e) {
          console.err("loadTrainingEndDate error", e);
        }
        UiUtil.loading(false);
      }
    },

    /**
     * QR 스캔 데이터를 통해서 입문 시간과 출문 시간을 업데이트한다
     * @param {boolean} isForce - true 이면 기존 입/출문 시간을 QR 기준으로 강제 재계산한다.
     * @param {boolean} silent - true 이면 완료 토스트를 표시하지 않는다. (작업일 변경 등 자동 재계산용)
     */
    updateQrTime(isForce = false, silent = false) {
      // startDate와 endDate를 yyyy-MM-dd 형식으로 변환
      const formatDate = (dateValue) => {
        if (!dateValue) return null;
        // 이미 yyyy-MM-dd 형식인 경우 그대로 반환
        if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
          return dateValue;
        }
        // Date 객체나 ISO 문자열인 경우 yyyy-MM-dd 형식으로 변환
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const formattedStartDate = formatDate(this.startDate);
      const formattedEndDate = formatDate(this.endDate);

      if (!formattedStartDate) {
        console.warn("startDate가 유효하지 않습니다.", this.startDate);
        return;
      }
      // endDate가 없으면 startDate 기준 24시간(당일)으로 검증
      const effectiveEndDate = formattedEndDate || formattedStartDate;

      if (this.qrList.length > 0) {
        this.localValue = this.localValue.map((item) => {
          const userQrs = this.qrList
            .filter((qr) => qr.user_id === item.userId)
            // QR 데이터 중에서, startDate 와 endDate 사이에 있는 데이터만 가져옵니다.
            .filter((qr) => new Date(qr.created_at) >= new Date(`${formattedStartDate} 00:00:00`) && new Date(qr.created_at) <= new Date(`${effectiveEndDate} 23:59:59`));

          let enterTime = "";
          let exitTime = "";

          if (userQrs.length > 0) {
            for (const qr of userQrs) {
              // qr.created_at 예시 : 2024-11-08 22:03:17
              const createdAt = new Date(qr.created_at);

              // qr.data === '입문' 이고, createdAt 값이 가장 작은 값이 입문시간
              if (qr.data === "입문") {
                if (enterTime === "" || new Date(enterTime) > createdAt) {
                  enterTime = qr.created_at;
                }
              }

              // qr.data === '출문' 이고, createdAt 값이 가장 큰 값이 출문시간
              if (qr.data === "출문") {
                if (exitTime === "" || new Date(exitTime) < createdAt) {
                  exitTime = qr.created_at;
                }
              }
            }
          }

          // QR 기준으로 채워진 값은 날짜가 함께 저장되고 시각에 초가 붙는다(HH:mm:ss).
          // 안전관리자가 수기로 입력한 값은 시각(HH:mm)만 있으므로, 강제 재계산 시 QR 기록이 없다고 해서 지우면 안 된다.
          // (QR 미스캔으로 안환팀이 수기 출문 처리한 작업자의 출문시간이 상세 화면에서 사라지던 문제)
          const isQrDerived = (date, time) => !!date || /^\d{2}:\d{2}:\d{2}$/.test(time || "");

          if (isForce) {
            if (enterTime) {
              item.입문날짜 = enterTime.split(" ")[0];
              item.입문시간 = enterTime.split(" ")[1];
            } else if (isQrDerived(item.입문날짜, item.입문시간)) {
              item.입문날짜 = "";
              item.입문시간 = "";
            }
          } else if (!item.입문시간 && enterTime) {
            item.입문날짜 = enterTime.split(" ")[0];
            item.입문시간 = enterTime.split(" ")[1];
          }
          if (isForce) {
            if (exitTime) {
              item.출문날짜 = exitTime.split(" ")[0];
              item.출문시간 = exitTime.split(" ")[1];
            } else if (isQrDerived(item.출문날짜, item.출문시간)) {
              item.출문날짜 = "";
              item.출문시간 = "";
            }
          } else if (!item.출문시간 && exitTime) {
            item.출문날짜 = exitTime.split(" ")[0];
            item.출문시간 = exitTime.split(" ")[1];
          }

          return item;
        });
      }

      if (!silent) {
        this.$toast.open({ type: "default", message: "QR 데이터를 불러왔습니다.", position: "bottom", duration: 2000 });
      }
    },

    changeIntroductionTime(value, tr) {
      if (!value) tr.출문시간 = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header {
  font-size: 14px;
  padding: 16px 0 !important;
}
.table::v-deep {
  th,
  th.td-check {
    padding: 16px 10px !important;
  }
  th,
  td {
    border: 1px solid #cdcdcd !important;
  }
  .vs-table--thead {
    z-index: inherit;
  }
}
</style>
